module.exports = __webpack_public_path__ + "static/media/Files-icon.f93e47a7.svg";